import { render } from "./DeliveryNoteVendor.vue?vue&type=template&id=2a47a9f9"
import script from "./DeliveryNoteVendor.vue?vue&type=script&lang=js"
export * from "./DeliveryNoteVendor.vue?vue&type=script&lang=js"

import "./DeliveryNoteVendor.vue?vue&type=style&index=0&id=2a47a9f9&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__